module.exports = __webpack_public_path__ + "images/chic-0113e193192172e9f775bbdf159ca3be.jpg";